import React, { useState, useEffect, } from "react";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";

function RevenueSettings(props) {
  const [editUser, setEditUser] = useState({
    user_id: "",
    admin_commission: "",
    user_commission: "",
    vod_admin_commission: "",
    vod_user_commission: "",
  });
  const [message, setMessage] = useState("");
  const access_token = localStorage.getItem("access_token");

  // console.log(access_token)

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  useEffect(async () => {
    const getUser = async () => {
      const reqData = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/Revenue-Setting/index`,
        { headers: headers }
      );

      const resData = await reqData?.json();
      var res = resData?.Revenue_Setting;
      setEditUser(res);
      // console.log(resData)
      // console.log(res)
    };
    getUser();
  }, []);

  const handleInput = (e) => {
    setEditUser({ ...editUser, [e.target.name]: e.target.value });
  };

  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  const handleUpdate = async (e) => {
    e.preventDefault();

    const editInputvalue = {
      user_id: editUser?.user_id,
      admin_commission: editUser?.admin_commission,
      user_commission: editUser?.user_commission,
      vod_admin_commission: editUser?.vod_admin_commission,
      vod_user_commission: editUser?.vod_user_commission,
    };

    let firstApiStatus = false;
    let resultapi = null;
    let resjson = null;
    setProcessing(true);
    setShowOverlay(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/Revenue-Setting/update`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify(editInputvalue),
        }
      );

      resjson = await res.json();

      if (resjson.status === true) {
        firstApiStatus = true;
        resultapi = resjson;
      }
    } catch (error) {
      console.error("Error:", error);
    }

    if (firstApiStatus) {
      props.setApiresponsealert(resultapi);
      props.setShowalert(true);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      if (resjson.status === false) {
        var resultError = resjson;
        props.setApiresponsealert(resultError);
        props.setShowalert(true);
        setProcessing(false);
        setShowOverlay(false);
      }
    }
  };

  return (
    <>
      {showOverlay && (<Response_Processing />)}
      <AdminSaveHeader heading={"Revenue Settings"} saveText={"Update Settings"} saveMethod={handleUpdate} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text={"Create Commission"} />
            <MessageLabel text={"Admin Commission in %"} />
            <AdminCustomInput type="number" min={0} max={100} id="admin_commission" placeHolder={"Enter admin commission %"} name="admin_commission" value={editUser?.admin_commission} onChange={handleInput} />
            <MessageLabel text={"VOD Admin Commission in %"} />
            <AdminCustomInput type="number" min={0} max={100} id="vod_admin_commission" placeHolder={"Enter VOD admin commission %"} name="vod_admin_commission" value={editUser?.vod_admin_commission} onChange={handleInput} />
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text={"User Commission"} />
            <MessageLabel text={"User Commission in %"} />
            <AdminCustomInput type="number" min={0} max={100} id="user_commission" placeHolder={"Enter user commission %"} name="user_commission" value={editUser?.user_commission} onChange={handleInput} />
            <MessageLabel text={"VOD User Commission in %"} />
            <AdminCustomInput type="number" min={0} max={100} id="vod_user_commission" placeHolder={"Enter VOD user commission %"} name="vod_user_commission" value={editUser?.vod_user_commission} onChange={handleInput} />
          </Wrapper>
        </RightWrapper>
      </FormContainer>
    </>
  );
}

export default RevenueSettings;
